import { render, staticRenderFns } from "./ViewInspectionFormComponent.vue?vue&type=template&id=b83327b8"
import script from "./ViewInspectionFormComponent.vue?vue&type=script&lang=js"
export * from "./ViewInspectionFormComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports